import styled from 'styled-components';
import { IoMdExpand } from 'react-icons/io';
import { IoTrashOutline } from 'react-icons/io5';
import { BiUndo, BiRedo } from 'react-icons/bi';

import FlowHeaderButton from './components/FlowHeaderButton';
import { RxPencil2 } from 'react-icons/rx';
import useFlowUtils from './hooks/useFlowUtils';
import ZoomController from './components/ZoomController';
import useUndoRedo from '../../hooks/useUndoRedo';
import { FLOW_HEADER_HEIGHT } from 'constants/style';

const Container = styled.div`
  height: ${`${FLOW_HEADER_HEIGHT}px`};
  border-bottom: 1px solid ${(props) => props.theme.global.borderColor};
  display: flex;
  padding: 0 12px;
  align-items: center;
`;

const Layout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ButtonsView = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const FlowHeader = () => {
  const { onCreateMemo, onFitView, onModelClear } = useFlowUtils();
  const { canRedo, canUndo, undo, redo } = useUndoRedo();

  return (
    <Container>
      <Layout>
        <ButtonsView>
          <FlowHeaderButton id="undo" tooltip="실행취소" Icon={BiUndo} onClick={undo} disabled={!canUndo} />
          <FlowHeaderButton id="redo" tooltip="다시실행" Icon={BiRedo} onClick={redo} disabled={!canRedo} />
          <FlowHeaderButton id="memo" tooltip="메모지" Icon={RxPencil2} onClick={onCreateMemo} />
          <FlowHeaderButton id="full" tooltip="화면 맞추기" Icon={IoMdExpand} onClick={onFitView} />
          <FlowHeaderButton id="clear" tooltip="전체삭제" Icon={IoTrashOutline} onClick={onModelClear} />
        </ButtonsView>
        <ZoomController />
      </Layout>
    </Container>
  );
};

export default FlowHeader;
